import { TIconName, TCIconsName } from 'components';
import { routePaths } from './routes';
import lamps from '../assets/icons/lamp.svg';
import shakeHand from '../assets/icons/shakeHand.svg';
import file from '../assets/icons/file.svg';
import warning from '../assets/icons/warning.svg';
import bags from '../assets/icons/bags.svg';
import paperCancel from '../assets/icons/paperCancel.svg';
import lapPhone from '../assets/icons/lapPhone.svg';
import paper from '../assets/icons/paper.svg';
import certification from '../assets/icons/certification.svg';
import document from '../assets/icons/document.svg';
import ideas from '../assets/icons/ideas.svg';
import contract from '../assets/icons/contract.svg';
import user from '../assets/icons/user.svg';
import control from '../assets/icons/control.svg';
import dashboard from '../assets/icons/dashboard.svg';
import user_gear_alt from 'assets/icons/user-gear-alt.svg';
import archive from 'assets/icons/archive.svg';
import simulator from 'assets/icons/simulator.svg';
import lawyer from 'assets/icons/lawyer.svg';

export interface IFunctionsItems {
  label: string;
  iconName?: TIconName;
  icon_string?: TCIconsName;
  iconString: string;
  disabled?: boolean;
  isPage: boolean;
  route?: string;
  userType?: 'admin' | 'client';
  typeUser?: string;
  hidden?: boolean;
}
export interface IconSvg {
  label?: string;
  iconName: string;
  route?: string;
}
interface IRoles {
  authority: string;
}
export const verificationRolesExists = (role: string) => {
  const value = localStorage.getItem('@dpohub/roles');
  if (typeof value === 'string') {
    const roles: IRoles[] = JSON.parse(value);
    const roleValidate = roles.map(item => item.authority === role).filter(item => item === true);
    // eslint-disable-next-line no-unneeded-ternary
    const isExists = roleValidate.length === 0 ? false : true;
    return isExists;
  }
};

// Enquanto algumas páginas ainda nao foram desenvolvidas, a validação delas esta sendo feita manualmente.Quando elas estiverem prontas é so descomentar a função q existe em cada disbled

export const ActivityItems: IFunctionsItems[] = [
  {
    label: 'Avaliação de Novos Projetos',
    iconName: 'lamps',
    iconString: lamps,
    route: routePaths.evaluationProject,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_AVALIACAO_NOVOS_PROJETOS')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'Avaliação de Terceiros',
    iconName: 'handShake',
    iconString: shakeHand,
    route: routePaths.thirdPartyAssessment,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') || verificationRolesExists('ROLE_ASSESSMENT_TERCEIROS')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'ROPA - Registro de Operação de Tratamento de Dados',
    iconName: 'fileChart',
    iconString: file,
    route: routePaths.ropa,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_REGISTRO_OPERACAO_TRATAMENTO_DADOS')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'DPIA - Relatório de Impacto à Proteção de Dados',
    iconName: 'warning',
    iconString: warning,
    // disabled:
    //   // eslint-disable-next-line no-unneeded-ternary
    //   verificationRolesExists('ROLE_ADMIN') ||
    //   verificationRolesExists('ROLE_RELATORIO_IMPACTO_PROTECAO_DADOS')
    //     ? false
    //     : true,
    disabled: true,
    isPage: false,
  },
  {
    label: 'Check-list ISO 271001',
    iconName: 'bag',
    iconString: bags,
    // disabled:
    //   // eslint-disable-next-line no-unneeded-ternary
    //   verificationRolesExists('ROLE_ADMIN') || verificationRolesExists('ROLE_CHECK_LIST_ISO_271001')
    //     ? false
    //     : true,
    disabled: true,
    isPage: false,
  },
  {
    label: 'Notificação de Incidente de Segurança',
    iconName: 'paper',
    iconString: paperCancel,
    // disabled:
    //   // eslint-disable-next-line no-unneeded-ternary
    //   verificationRolesExists('ROLE_ADMIN') ||
    //   verificationRolesExists('ROLE_NOTIFICACAO_INCIDENTE_SEGURANCA')
    //     ? false
    //     : true,
    disabled: true,
    isPage: false,
  },
  {
    label: 'Checklist de Site e Apps',
    iconName: 'lapTop',
    iconString: lapPhone,
    // disabled:
    //   // eslint-disable-next-line no-unneeded-ternary
    //   verificationRolesExists('ROLE_ADMIN') || verificationRolesExists('ROLE_CHECK_LIST_SITES_APPS')
    //     ? false
    //     : true,
    disabled: true,
    isPage: false,
  },
  {
    label: 'Avaliação de Gravidade de Incidente (ENISA)',
    iconName: 'filealt',
    iconString: paper,
    // disabled:
    //   // eslint-disable-next-line no-unneeded-ternary
    //   verificationRolesExists('ROLE_ADMIN') ||
    //   verificationRolesExists('ROLE_NOTIFICACAO_INCIDENTE_SEGURANCA')
    //     ? false
    //     : true,

    disabled: true,
    isPage: false,
  },
  {
    label: 'Avaliação de Legítimo Interesse',
    iconName: 'filealt',
    iconString: certification,
    route: routePaths.ali,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_TESTE_LEGITIMO_INTERESSE')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'Simulador de multas',
    iconName: 'filealt',
    iconString: simulator,
    route: routePaths.simulatedFines,
    disabled: false,
    isPage: true,
  },
  // {
  //   label: 'Minhas Avaliações',
  //   iconName: 'filealt',
  //   route: routePaths.myAvaliations,
  // },
];

export const UserItems: IFunctionsItems[] = [
  {
    label: 'Controle Orçamentário',
    iconName: 'task',
    iconString: control,
    route: routePaths.budgetControl,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') || verificationRolesExists('ROLE_CONTROLE_ORCAMENTARIO')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'Dashboards',
    iconName: 'task',
    iconString: dashboard,
    route: routePaths.dashBoard,
    isPage: true,
  },
];

export const ManagementItems: IFunctionsItems[] = [
  {
    label: ' Gerenciamento de Usuários',
    iconName: 'task',
    iconString: user,
    route: routePaths.users,
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') || verificationRolesExists('ROLE_GESTAO_USUARIOS')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'Gerenciamento de Advogados',
    iconName: 'arrowLeft',
    iconString: lawyer,
    route: routePaths.lawyerManagement,
    disabled: false,
    isPage: true,
  },
];

export const SolicitationsItemsClient: IFunctionsItems[] = [
  {
    label: 'Documentos',
    iconName: 'regfilealt',
    iconString: document,
    route: routePaths.newClientDemands + '?serviceType=9',
    // userType: 'client',
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'Contratos',
    iconName: 'regfilealt',
    iconString: contract,
    route: routePaths.newClientDemands + '?serviceType=12',
    // userType: 'client',
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS')
        ? false
        : true,
    isPage: true,
  },
  {
    label: 'Consultas',
    iconName: 'regfilealt',
    iconString: ideas,
    route: routePaths.newClientDemands + '?serviceType=2',
    // userType: 'client',
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS')
        ? false
        : true,
    isPage: true,
  },
];
export const SolicitationItemAdmin: IFunctionsItems[] = [
  {
    label: 'Solicitações',
    iconString: user_gear_alt,
    route: routePaths.newDemand,
    userType: 'admin',
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS')
        ? false
        : true,
    isPage: true,
  },
];

export const SolicitationDanielLaw: IFunctionsItems[] = [
  {
    label: 'Solicitações Arquivadas',
    iconString: archive,
    route: routePaths.filedDemands,
    userType: 'admin',
    disabled:
      // eslint-disable-next-line no-unneeded-ternary
      verificationRolesExists('ROLE_ADMIN') ||
      verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS')
        ? false
        : true,
    isPage: true,
  },
];
